import { contraindicationApi } from "api/immunization";
import { humanise } from "config/immunizationConstants";
import MasterListScreen from "./common/MasterListScreen";
import ContraindicationModal from "./ContraindicationModal";

const appliesToLabel = (item) => {
  if (item.appliesToAll) return "All vaccines";
  const antigens = (item.appliesToAntigenIds || []).length;
  const products = (item.appliesToProductIds || []).length;
  return (
    [
      antigens ? `${antigens} antigen(s)` : null,
      products ? `${products} product(s)` : null,
    ]
      .filter(Boolean)
      .join(", ") || "—"
  );
};

const ContraindicationList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={contraindicationApi}
    label="Contraindication"
    entityLabel="contraindication"
    addLabel="Add Contraindication"
    tag="immunization-contraindication"
    headers={[
      "Name",
      "Code",
      "Type",
      "Applies To",
      "Override",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "typeLabel",
      "appliesToLabel",
      "overrideLabel",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.conditionName}
    mapRow={(item) => ({
      typeLabel: item.type === "FALSE" ? "False (myth)" : humanise(item.type),
      appliesToLabel: appliesToLabel(item),
      overrideLabel: item.overridePermitted ? "Permitted" : "Not permitted",
    })}
    Modal={ContraindicationModal}
    searchText={searchText}
  />
);

export default ContraindicationList;
